<template>
  <div  class="first_page landing_first_page" >
    <loading-block v-if="is_show_loader" :loading="is_show_loader"/>

    <div v-if="is_load" >

      <section class="section block_landing block_landing_type_one"   v-for="(block,block_key) in blocks" :key="block_key" >

        <div class="inside_landing row d-flex justify-content-center">


          <div class="section_header mobile_div w-100" v-if="block.isshowtitle==1">
            <h4 class="display-4 text-megablue m-3" v-if="block.isshowtitle==1">{{ block.title}}</h4>
          </div>








          <div class="content_block mobile_div    ml-3 mb-3 mr-3 w-100" v-if="block.before && block.before.length>0"  v-for="(text,text_before_key) in block.before" :key="text_before_key">
            <editorjsrender  class=" ml-3 mb-3 mr-3"  :align_style="'center'" v-if="text.content.blocks " :blocks_json="text.content.blocks"></editorjsrender>
          </div>

            <posts-widget v-if="block.type=='blog_home'"></posts-widget>
            <lk-widget :block="block" :first_tab="block.first_tab" v-if="block.type=='lk_widget' && block.isready==true"></lk-widget>
          <div class="row mobile_div section_header" v-if="block.type.includes('pages_category_') && block.category.list_style=='3_in_1' && block.pages.length>0">
            <div class="col-12 col-lg-4 col-md-4 mb-5 mb-lg-0 mt-2 mb-2 " v-for="page in block.pages" :key="page.id">
              <div class="p-3  page_block_mini">
                <h2 class="ml-3 text-center">{{ page.title }}</h2>
                <editorjsrender :align_style="'center'"  :blocks_json="page.content.blocks" :isshort="true"></editorjsrender>

                <div class="col-12 d-flex justify-content-center pt-3">
                  <router-link class="btn " :to="{name: 'pages_page',params:{alias:block.category.alias,page_alias:page.alias}}"
                  >
                    Читать далее
                  </router-link>
                </div>
              </div>

            </div>



          </div>
          <div class="row section_header mobile_div" v-if="block.type.includes('pages_category_') && block.category.list_style=='2_in_1' && block.pages.length>0">
            <div class="col-12 col-lg-6 col-md-6 mb-5 mb-lg-0 mt-2 mb-2 " v-for="page in block.pages" :key="page.id">
              <div class="p-3 page_block_mini ">
                <h2 class="ml-3 text-center">{{ page.title }}</h2>
                <editorjsrender :align_style="'center'"  :blocks_json="page.content.blocks" :isshort="true"></editorjsrender>

                <div class="col-12 pt-3 d-flex justify-content-center">
                  <router-link class="btn " :to="{name: 'pages_page',params:{alias:block.category.alias,page_alias:page.alias}}"
                  >
                    Читать далее
                  </router-link>
                </div>
              </div>

            </div>



          </div>
         <div class="" v-if="block.type=='items' && block.items.length>0">
           <div class="section_header mobile_div nocenter row    d-flex justify-content-center" v-if="block.type=='items' && block.items.length>0">

             <div class="col-6 col-sm-6 col-lg-2 col-md-3 item_card_container   "  v-for="(item,item_index) in block.items" :key="item_index" >
               <div class="item_card_mini">
                 <div class="item_data">
                   <div class="shop-item-image">
                     <router-link class="" :to="{name: 'shop_item_id', params: {id:item.last_id }}" tag="a" ><v-lazy-image :src="item.photos[0]"  alt="..."/></router-link>
                   </div>


                   <div class="shop-item-title d-flex justify-content-center"> <router-link class=" " :to="{name: 'shop_item_id', params: {id:item.last_id }}" tag="a" > {{ item.title}}</router-link></div>
                   <p><span class="shop-item-price">{{ item.price}} {{ item.currency}}</span></p>
                   <!--            <div class="row text-center">-->

                   <!--                <h3>{{ item.count}}</h3>-->

                   <!--            </div>-->
                   <!--            <div class="row mb-2">-->
                   <!--              <div class="col-5">-->
                   <!--                <button type="button" @click="changeType(item_index,'-')" class="btn" v-if="count_arr['last_id_'+item.last_id]>0">-</button>-->
                   <!--              </div>-->

                   <!--              <div class="col-5">-->
                   <!--                <button type="button" @click="changeType(item_index,'+')" class="btn">+</button>-->

                   <!--              </div>-->
                   <!--            </div>-->


                 </div>
               </div>

             </div>

           </div>

           <div class="row team_list m-3" v-if="block.type=='items' && items.length>0" >
             <div  class="text-center col-12">
               <router-link :to="{name: 'shop_categorys'}" class="btn">Посмотреть все</router-link>

             </div>
           </div>
         </div>

            <div class="w-100" v-if="block.type.includes('items_') && block.items && block.items.length>0">
              <div class="row section_header mobile_div nocenter     d-flex justify-content-center" v-if="block.items.length>0">

                <div class="col-6 col-sm-6 col-lg-2 col-md-3 item_card_container   "  v-for="(item,item_index) in block.items" :key="item_index" >
                  <div class="item_card_mini">
                    <div class="item_data">
                      <div class="shop-item-image">
                        <router-link class="" :to="{name: 'shop_item_id', params: {id:item.last_id }}" tag="a" ><v-lazy-image :src="item.photos[0]"  alt="..."/></router-link>
                      </div>


                      <div class="shop-item-title d-flex justify-content-center"> <router-link class=" " :to="{name: 'shop_item_id', params: {id:item.last_id }}" tag="a" > {{ item.title}}</router-link></div>
                      <p><span class="shop-item-price">{{ item.price}} {{ item.currency}}</span></p>
                      <!--            <div class="row text-center">-->

                      <!--                <h3>{{ item.count}}</h3>-->

                      <!--            </div>-->
                      <!--            <div class="row mb-2">-->
                      <!--              <div class="col-5">-->
                      <!--                <button type="button" @click="changeType(item_index,'-')" class="btn" v-if="count_arr['last_id_'+item.last_id]>0">-</button>-->
                      <!--              </div>-->

                      <!--              <div class="col-5">-->
                      <!--                <button type="button" @click="changeType(item_index,'+')" class="btn">+</button>-->

                      <!--              </div>-->
                      <!--            </div>-->


                    </div>
                  </div>

                </div>

              </div>

              <div class="row section_header mobile_div" v-if="block.items.length>0" >
                <div  class="text-center col-12">
                  <router-link :to="{name: 'shop_categorys','query':{category_id:block.category.last_id}}" class="btn">Посмотреть все</router-link>

                </div>
              </div>
            </div>

          <div class="w-100"  v-if="block.type=='developers' && block.developers.rows.length>0">
            <div class="row team_list m-3" v-if="block.type=='developers' && block.developers.rows.length>0" >
              <div class="col-md-6 col-lg-4 mb-5 mb-lg-0 " v-for="developer in block.developers.rows" :key="developer.last_id">
                <div class="px-4 text-center block_row pt-2">
                  <router-link :to="{name: 'user_page_main', params: { user_id: developer.last_id }}" class="">
                    <avatar v-if="developer.avatar==null" :username="developer.name" :size="180"
                        class="rounded-circle img-center img-fluid shadow shadow-lg--hover"></avatar>

                    <v-lazy-image v-if="developer.avatar!=null" :src="image_url+developer.avatar"
                        class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                        style="width: 200px;"/>
                  </router-link>
                  <div class="container mt-2" v-if="developer.rating">
                    <div class="row">
                      <div class="col-12 mx-auto d-flex align-items-center justify-content-center">
                        <p class="text-center">Рейтинг: <router-link tag="a" :to="{name:'user_page_reviews',params: { user_id: developer.last_id }}"><span class="badge badge-circle badge-info">{{ developer.rating}}</span></router-link></p>
                      </div>
                    </div>
                  </div>
                  <div class="pb-4 mt-2 text-center">
                    <h5 class="title">

                      <router-link tag="a" :to="{name: 'user_page_main', params: { user_id: developer.last_id }}" class=" btn">
                        <span class="d-block mb-1 ">{{ developer.name }}</span></router-link>

                    </h5>


                  </div>
                </div>
              </div>

            </div>

            <div class="col-12 d-flex justify-content-center team_list m-3" v-if="block.type=='developers' && block.developers.rows.length>0" >

              <router-link :to="{name: 'users_list'}" class="btn">Посмотреть всех</router-link>


            </div>
          </div>

          <div class="row col-12 col-md-12 col-sm-12 col-lg-12 "  v-if="block.type=='team' && block.teams.length>0">
            <div class="col-12 col-sm-6 col-md-6 col-lg-6 " v-for="team in block.teams" :key="team.last_id"
                v-if="block.teams.length>0">
              <div class="section_header">
                <router-link :to="{name: 'user_page_main', params: { user_id: team.last_id }}" class="">
                  <avatar v-if="team.avatar==null" :username="team.name" :size="180"
                      class="rounded-circle img-center img-fluid shadow shadow-lg--hover"></avatar>

                  <v-lazy-image v-if="team.avatar!=null" :src="image_url+team.avatar"
                      class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                      style="width: 200px;"/>
                </router-link>
                <div class="pb-4 mt-2 text-center">
                  <h5 class="title">

                    <router-link tag="a" :to="{name: 'user_page_main', params: { user_id: team.last_id }}" class=" btn btn-sm">
                      <span class="d-block mb-1 ">{{ team.name }}</span></router-link>

                  </h5>
                  <small class="h6 ">{{ team.job }}</small>

                </div>
              </div>
            </div>
          </div>





          <div class="row shops_list m-3 d-flex justify-content-center block_data " v-if="block.type=='shops' && block.shops.length>0">
            <div class="col-12 col-md-4 col-lg-4   " v-for="shop_vendor in block.shops" :key="shop_vendor.last_id"
                 v-if="block.shops.length>0">
              <div class="p-3 block_row">
                <router-link :to="{name: 'user_page_items', params: { user_id: shop_vendor.last_id }}">
                  <avatar v-if="shop_vendor.avatar==null" :username="shop_vendor.name" :size="180"
                          class="rounded-circle img-center img-fluid shadow shadow-lg--hover"></avatar>

                  <v-lazy-image v-if="shop_vendor.avatar!=null" :src="image_url+shop_vendor.avatar"
                       class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                       style="width: 200px;"/>
                </router-link>
                <div class="pb-4 text-center">
                  <h5 class="title">

                    <small class="h6 text-black" >{{ shop_vendor.name }}</small>
                  </h5>
                  <div class="mt-3">
                    <router-link class="btn btn-sm" :to="{name: 'user_page_items', params: { user_id: shop_vendor.last_id }}" tag="a">Посмотреть</router-link>

                  </div>
                </div>
              </div>
            </div>

          </div>
            <div class="row d-flex justify-content-center block_data  m-3" v-if="block.type=='blog_categorys' && block.blog_categorys.length>0">

              <div class=" col-12 col-md-3  d-flex justify-content-center blog_category_link section_gray_bg" v-for="blog_category in block.blog_categorys"
                   :key="blog_category.last_id">
                <router-link   :to="blog_category.alias" class="" tag="a">
                  <v-lazy-image class="img-fluid" :src="image_url+blog_category.image"/>
                  <p>{{ blog_category.title}}</p>

                </router-link>
              </div>

            </div>


              <div class="section_header mobile_div row nocenter"  v-if="block.type=='posts' && block.posts && block.posts.length>0">


                <div class="col-12 mobile_div col-md-6 col-lg-4  mt-3"
                    v-for="post in block.posts"
                    :key="post.last_id">
                  <div class="p-3 post_on_home  page_block_mini m-3">
                    <div class="media">
                      <v-lazy-image :src="image_url+post.category_post.image"   class="mr-3" style="max-width: 50px; max-height: 50px;"/>
                      <div class="media-body">
                        <h5 class="mt-0">{{ post.category_post.title }}</h5>
                      </div>
                    </div>



                    <div class="post_material_mini_content">
                      <editorjsrender  :blocks_json="post.short.blocks"></editorjsrender>
                    </div>
                    <div class="d-flex justify-content-between post_material_mini_bottom">
                      <p><i class="fa fa-calendar-o"></i><small>&nbsp; {{ post.created_at }}</small></p>
                      <p><i class="fa fa-comment-0"></i>  ({{ post.total_comments_count }})</p>
                    </div>


                    <div class="col-12 d-flex justify-content-center">
                      <router-link class="btn " :to="{name: 'post', params: { id: post.last_id,'alias':post.category_post.alias }}"
                      >
                        Читать далее
                      </router-link>
                    </div>

                  </div>




                </div>



              </div>

                <div class="w-100 section_header mobile_div d-flex justify-content-center  team_list" v-if="block.type=='posts' && block.posts && block.posts.length>0"   >

                  <router-link :to="{name: 'posts'}" class="btn">Посмотреть все</router-link>


                </div>




            <div v-if="block.type.includes('posts_') && block.posts && block.posts.length>0">
              <div class="section_header mobile_div row nocenter" >


                <div class="col-12 mobile_div col-md-6 col-lg-4  mt-3"
                    v-for="post in block.posts"
                    :key="post.last_id">
                  <div class="post_material_mini post_on_home  block_row m-3">
                    <div class="media">
                      <v-lazy-image :src="image_url+post.category_post.image"   class="mr-3" style="max-width: 50px; max-height: 50px;"/>
                      <div class="media-body">
                        <h5 class="mt-0">{{ post.category_post.title }}</h5>
                      </div>
                    </div>



                    <div class="post_material_mini_content">
                      <editorjsrender  :blocks_json="post.short.blocks"></editorjsrender>
                    </div>
                    <div class="d-flex justify-content-between post_material_mini_bottom">
                      <p><i class="fa fa-calendar-o"></i><small>&nbsp; {{ post.created_at }}</small></p>
                      <p><i class="fa fa-comment-0"></i>  ({{ post.total_comments_count }})</p>
                    </div>


                    <div class="col-12 d-flex justify-content-center">
                      <router-link class="btn " :to="{name: 'post', params: { id: post.last_id,'alias':post.category_post.alias }}"
                      >
                        Читать далее
                      </router-link>
                    </div>

                  </div>




                </div>



              </div>
              <div class="">
                <div class="col-12 section_header mobile_div d-flex justify-content-center  team_list"   >

                  <router-link :to="{name: 'category_blog',params:{alias:block.category.alias}}" class="btn">Посмотреть все</router-link>


                </div>
              </div>
            </div>
          <div class="" v-if="block.type=='portfolio'">
            <div v-if="block.type=='portfolio'" class="section_header mobile_div portfolio_list tags_list_block">
              <div class="row col-md-12 mt-3 d-flex justify-content-center">
                <p><button   class="btn ml-2 mr-2 "   :class="{ 'tag_not_active': !(current_portfolio_tag && current_portfolio_tag=='all_works_tag'),'tag_active': (current_portfolio_tag && current_portfolio_tag=='all_works_tag') }"     @click="openPortfolioTag('all_works_tag')">
                  все работы
                </button></p>
                <p v-if="tags.length>0" v-for="(tag,tag_key) in tags" :key="tag_key"  class="">

                  <button   class="btn ml-2 mr-2" :class="{ 'tag_not_active': !(tag.tag && current_portfolio_tag && current_portfolio_tag==tag.tag),'tag_active': (tag.tag && current_portfolio_tag && current_portfolio_tag==tag.tag) }"     @click="openPortfolioTag(tag.tag)">
                    {{ tag.title}}
                  </button>&nbsp;&nbsp;
                </p>
              </div>
            </div>
            <div v-if="block.type=='portfolio'" class="section_header mobile_div row justify-content-center">





              <div class="card portfolio_block_work portfolio_work_landing_block col-12 col-sm-4 card-work m-3"   v-if="((show_all_portfolio==true) || (show_all_portfolio==false && work_index<6)) && works_by_tag[current_portfolio_tag] && works_by_tag[current_portfolio_tag].length>0"  v-for="(work,work_index) in works_by_tag[current_portfolio_tag]" :key="work_index">
                <router-link  tag="a"
                    :to="{name: 'user_page_one_portfolio', params: { user_id: work.user.last_id,work_id:work.last_id }}"><v-lazy-image class="card-img-top" :src="work.image" alt="Card image cap"/></router-link>
                <div class="card-body">
                  <h5 class="card-title"><b>Название</b>:<router-link  tag="a"
                      :to="{name: 'user_page_one_portfolio', params: { user_id: work.user.last_id,work_id:work.last_id }}">{{ work.name}}</router-link></h5>
                  <p class="card-text"><b>Категория</b>- <router-link  tag="a"
                      :to="{name: 'works_in_category', params: { category_id: work.category_id,work_id:work.last_id }}">{{ work.category.name }}</router-link></p>
                  <p class="card-text"> </p>
                  <div class="d-flex align-items-center">
                    <v-lazy-image :src="image_url+work.user.avatar" alt="Avatar" class="rounded-circle mr-2" style="width:50px; height:50px;"/>
                    <p class="card-text mb-0"><router-link  tag="a"
                        :to="{name: 'user_page_main', params: { user_id: work.user.last_id }}">{{ work.user.name}}</router-link></p>
                  </div>
                </div>
              </div>

              <div v-if="works_by_tag[current_portfolio_tag] && works_by_tag[current_portfolio_tag].length>6 && show_all_portfolio==true" class="text-center col-12">
                <button class="btn" @click="show_all_portfolio=false;">Скрыть {{ works_by_tag[current_portfolio_tag].length-6}}</button>
              </div>
              <div v-if="works_by_tag[current_portfolio_tag] && works_by_tag[current_portfolio_tag].length>6 && show_all_portfolio==false" class="text-center col-12">
                <button class="btn" @click="show_all_portfolio=true;">Показать еще {{ works_by_tag[current_portfolio_tag].length-6}} </button>
              </div>







            </div>
          </div>


            <div class="" v-if="block.type=='services' && block.services.length>0">
              <div class="d-flex justify-content-center" v-if="block.type=='services'">
                <div v-if="block.type=='services' && block.services.length>0" class="container   m-3">
                  <div class="second_section  row row-grid align-items-center " v-for="(category,category_index) in block.services" :key="category_index"
                      v-if="block.services.length>0">
                    <div class="col-md-6 order-md-2">
                      <v-lazy-image :src="image_url+category.image" class="img-fluid floating"/>
                    </div>
                    <div class="col-md-6 order-md-1">
                      <h2 class="text-center">{{ category.name }}</h2>
                      <editorjsrender :align_style="'center'" v-if="category.content_json && category.content_json.blocks"  :blocks_json="category.content_json.blocks" :isshort="true"></editorjsrender>
                      <div class="col-12 mt-2 text-center">
                        <p>    <router-link class="btn " tag="a"
                            :to="{name: 'service_new_request',params:{id:category.last_id}}">Заказать</router-link></p>
                        <p>  <router-link class="btn" tag="a"
                            :to="{name: 'service_page', params: {service_id:category.last_id  }}">Подробнее</router-link></p>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              <div    v-if="block.type=='services' && block.services.length>1" class="  ">
                <div class="section_header d-flex justify-content-center">
                  <!--            <img src="img/guy-pointing-down.png" class="img-fluid">-->
                  <router-link class="btn  text-wrap " tag="a"
                      :to="{name: 'services'}">Посмотреть <br> все услуги</router-link>
                </div>
              </div>
            </div>



          <div class="content_block col-12   mobile_div mt-3 ml-3 mb-3 mr-3 w-100" v-if="block.after && block.after.length>0" v-for="(text,text_after_key) in block.after" :key="text_after_key">
            <editorjsrender :align_style="'center'" class="mt-3 ml-3 mb-3 mr-3"   v-if="text.content.blocks " :blocks_json="text.content.blocks"></editorjsrender>
          </div>
        </div>

      </section>







    </div>


  </div>
</template>

<script>
import {vueTelegramLogin} from 'vue-telegram-login'
import axios from 'axios';
import Api from "../models/Api";
import Vue from "vue";
import Carousel from "../views/components/Carousel";
import AppHeader from "@/layout/AppHeader";
import {eventBus} from '../main.js';
import Modal from "@/components/Modal";
import Loading from 'vue-loading-overlay';

import 'vue-loading-overlay/dist/vue-loading.css';
import Editorjsrender from "@/models/Editorjsrender";

import { BCarousel } from "bootstrap-vue/esm/components/carousel/carousel";
import { BCarouselSlide } from "bootstrap-vue/esm/components/carousel/carousel-slide";
import LoadingBlock from "../components/Custom/LoadingBlock";
import LkWidget from "../components/Custom/LkWidget";
import PostsWidget from "../components/Custom/PostsWidget";
import VLazyImage from "v-lazy-image/v2";


var Avatar = require('vue-avatar');


export default {
  name: 'home',


  components: {VLazyImage,PostsWidget,LoadingBlock,LkWidget, BCarousel,
    BCarouselSlide, Modal, vueTelegramLogin, 'avatar': Avatar.Avatar, 'editorjsrender': Editorjsrender,},
  data() {
    return {
       "current_work":0,

      "show_all_portfolio":false,
      'works_by_tag':{},
      "istgbot": false,
      "is_show_loader": true,
      "telegram_bot": null,
      "islogin": false,
      "current_portfolio_tag":null,
      "config": {},


      "is_load": false,
      "about": null,
      "posts": null,
      "categorys": null,
      "image_url": null,
      "tags":null,
      "teams": null,
      "developers":[],
      "items":[],
      "shops":null,
      "works": null,
      "iserror": false,
      "error_message": null,
      "form": {
        'json': {},
      },
      "loaded_categorys": false,
      "categorys_modal": null,
      "modal_title": "Создать проект",
      'modals': {
        "add": null,
      },
      "slide": 0,
      "sliding": null,
      "text_block":{
         "first":"",
         "second":"",

      },
      'blocks':[],
      'blog_categorys':[],
      'background_image':'',
      'title_site':'',
    }
  },
  mounted() {

    //AppHeader.methods["testLog"]();
    var app = this;
    app.telegram_bot = Vue.config.TG_BOT;


    app.istgbot = true;
    app.islogin = false;
    if (app.$store.getters.ISAUTH) {
      var tmpUser = app.$store.getters.USER;

      app.user = tmpUser;
      app.islogin = true;


    }

    eventBus.$on('user_is_login', user => {
      this.islogin = false;
      if (typeof user === 'object') {
        if (user.api_token) {
          app.user = user;
          app.islogin = true;

        }
      }


    });


    Api.loadAbout(function (data) {

      app.about = data.about;
      app.image_url = Vue.config.IMAGE_URL;

      app.blocks=data.blocks;

      if(data.about) {
        app.text_block.first = data.about.first_content;
        app.text_block.second = data.about.second_content;
        app.background_image =  app.image_url+data.about.image;
        app.title_site=app.about.title;
      }

      if(app.blocks.length>0){
        app.blocks.forEach(function(block){
          if(block.type=='portfolio'){
            var current_works=block.works;
            var works_by_tag={};
            var tags=block.offer_tags;
            if(tags.length>0){
              tags.forEach(function(tag){
                var tag_works=[];
                if(current_works.length>0){

                  current_works.forEach(function(current_work){
                    if(current_work.tags.tags.includes(tag.tag)){
                      tag_works.push(current_work);
                    }
                  });
                }
                works_by_tag[tag.tag]=tag_works;


              });


            }
            works_by_tag["all_works_tag"]=current_works;
            app.works_by_tag=works_by_tag;


            app.tags=block.offer_tags;

            app.current_portfolio_tag="all_works_tag";
          }
        });
      }







      app.is_load = true;
      app.is_show_loader = false;

    })
  },
  methods: {
    callModalAddProject() {
      eventBus.$emit("call_modal_add_project", {})
      {

      }
    },
    onSlideStart(slide) {
      this.sliding = true
    },
    onNextWork(){
      var app=this;
      var next_work=app.current_work+1;
      if(app.works[next_work]){
        app.current_work=next_work;
      }
    },
    onPrevWork(){
      var app=this;
      var prev_work=app.current_work-1;
      if(prev_work>=0 && app.works[prev_work]){
        app.current_work=prev_work;
      }
    },
    onSlideEnd(slide) {
      this.sliding = false
    },
    openPortfolioTag(tag){
      var app=this;
      app.current_portfolio_tag=tag;
      return false;

    },
    downloadPdfOffer(tag){
     Api.download_pdf_offer(tag);

     return false;

    },
    getBackgroundImage(){
      return this.background_image;
    }



  }
};
</script>